<template>
  <el-form-item :prop="prop" class="form-item" :show-message="false">
    <slot>
      <el-input v-model="model[prop]" :disabled="disabled" />
    </slot>
  </el-form-item>
</template>

<script>
export default {
  name: 'RestListColumnEditable',
  props: {
    model: {
      type: Object,
      required: true
    },
    prop: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.el-form-item {
  z-index: 51;
  margin-bottom: 20px;
  &.form-item {
    position: absolute;
    top: 3px;
    width: calc(100% - 20px);
  }
}
</style>



// WEBPACK FOOTER //
// src/common/components/rest/RestListColumnEditable.vue